export enum Currency {
  USD = 'USD',
  EUR = 'EUR',
  GBP = 'GBP',
  INR = 'INR',
  AUD = 'AUD',
  CAD = 'CAD',
  SGD = 'SGD',
  CHF = 'CHF',
  MYR = 'MYR',
  JPY = 'JPY',
  CNY = 'CNY',
  NZD = 'NZD',
  THB = 'THB',
  HUF = 'HUF',
  AED = 'AED',
  HKD = 'HKD',
  MXN = 'MXN',
  ZAR = 'ZAR',
  PHP = 'PHP',
  SEK = 'SEK',
  IDR = 'IDR',
  SAR = 'SAR',
  BRL = 'BRL',
  TRY = 'TRY',
  KES = 'KES',
  KRW = 'KRW',
  EGP = 'EGP',
  IQD = 'IQD',
  NOK = 'NOK',
  KWD = 'KWD',
  RUB = 'RUB',
  DKK = 'DKK',
  PKR = 'PKR',
  ILS = 'ILS',
  PLN = 'PLN',
  QAR = 'QAR',
  XAU = 'XAU',
  OMR = 'OMR',
  COP = 'COP',
  CLP = 'CLP',
  TWD = 'TWD',
  ARS = 'ARS',
  CZK = 'CZK',
  VND = 'VND',
  MAD = 'MAD',
  JOD = 'JOD',
  BHD = 'BHD',
  XOF = 'XOF',
  LKR = 'LKR',
  UAH = 'UAH',
  NGN = 'NGN',
  TND = 'TND',
  UGX = 'UGX',
  RON = 'RON',
  BDT = 'BDT',
  PEN = 'PEN',
  GEL = 'GEL',
  XAF = 'XAF',
  FJD = 'FJD',
  VEF = 'VEF',
  BYN = 'BYN',
  HRK = 'HRK',
  UZS = 'UZS',
  BGN = 'BGN',
  DZD = 'DZD',
  IRR = 'IRR',
  DOP = 'DOP',
  ISK = 'ISK',
  XAG = 'XAG',
  CRC = 'CRC',
  SYP = 'SYP',
  LYD = 'LYD',
  JMD = 'JMD',
  MUR = 'MUR',
  GHS = 'GHS',
  AOA = 'AOA',
  UYU = 'UYU',
  AFN = 'AFN',
  LBP = 'LBP',
  XPF = 'XPF',
  TTD = 'TTD',
  TZS = 'TZS',
  ALL = 'ALL',
  XCD = 'XCD',
  GTQ = 'GTQ',
  NPR = 'NPR',
  BOB = 'BOB',
  ZWD = 'ZWD',
  BBD = 'BBD',
  CUC = 'CUC',
  LAK = 'LAK',
  BND = 'BND',
  BWP = 'BWP',
  HNL = 'HNL',
  PYG = 'PYG',
  ETB = 'ETB',
  NAD = 'NAD',
  PGK = 'PGK',
  SDG = 'SDG',
  MOP = 'MOP',
  NIO = 'NIO',
  BMD = 'BMD',
  KZT = 'KZT',
  PAB = 'PAB',
  BAM = 'BAM',
  GYD = 'GYD',
  YER = 'YER',
  MGA = 'MGA',
  KYD = 'KYD',
  MZN = 'MZN',
  RSD = 'RSD',
  SCR = 'SCR',
  AMD = 'AMD',
  SBD = 'SBD',
  AZN = 'AZN',
  SLL = 'SLL',
  TOP = 'TOP',
  BZD = 'BZD',
  MWK = 'MWK',
  GMD = 'GMD',
  BIF = 'BIF',
  SOS = 'SOS',
  HTG = 'HTG',
  GNF = 'GNF',
  MVR = 'MVR',
  MNT = 'MNT',
  CDF = 'CDF',
  STD = 'STD',
  TJS = 'TJS',
  KPW = 'KPW',
  MMK = 'MMK',
  LSL = 'LSL',
  LRD = 'LRD',
  KGS = 'KGS',
  GIP = 'GIP',
  XPT = 'XPT',
  MDL = 'MDL',
  CUP = 'CUP',
  KHR = 'KHR',
  MKD = 'MKD',
  VUV = 'VUV',
  MRO = 'MRO',
  ANG = 'ANG',
  SZL = 'SZL',
  CVE = 'CVE',
  SRD = 'SRD',
  XPD = 'XPD',
  SVC = 'SVC',
  BSD = 'BSD',
  XDR = 'XDR',
  RWF = 'RWF',
  AWG = 'AWG',
  DJF = 'DJF',
  BTN = 'BTN',
  KMF = 'KMF',
  WST = 'WST',
  SPL = 'SPL',
  ERN = 'ERN',
  FKP = 'FKP',
  SHP = 'SHP',
  JEP = 'JEP',
  TMT = 'TMT',
  TVD = 'TVD',
  IMP = 'IMP',
  GGP = 'GGP',
  ZMW = 'ZMW',
}



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/client/src/model/currency.ts